import React, { useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment-timezone'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'
import Name from './Name'
import JointMasterNumber from './JointMasterNumber'
import styles from './JointlyOwnedVehicleInformation.module.scss';
import { listAddAction, listEditAction, changeObjectPropertyAction } from 'redux/actions';
import { findDuplicateMasterNumber } from "../../../../redux/reducers/appReducer";

const PersonalInformationView = ({ t, i18n, match, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch();
  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [nameValid, setNameValid] = useState('')
  const [jointMasterNumberValid, setJointMasterNumberValid] = useState('')

  const [nameError, setNameError] = useState('jointly_owned_vehicle_info.name_error')
  const [jointMasterNumberError, setJointMasterNumberError] = useState('jointly_owned_vehicle_info.joint_master_number_error')

  const { name, jointMasterNumber, editMasterNumber } = useSelector((state) => state.app.jointlyOwnedVehicleInformation)
  const [errMsg, setErrMsg] = useState('');
  const houseHoldMembers = useSelector((state) => state.app.personalInformation.houseHoldMembers);
  const jointVehicles = useSelector((state) => state.app.jointlyOwnedVehicleInformation.vehicles);
  const businessVehicles = useSelector((state) => state.app.businessVehicleInformation.businessVehicles);

  const { driverLicence } = useSelector((state) => state.app.addressTypeChange);
  // const { jointlyRegistered, registeredBusiness } = useSelector((state) => state.app.addressTypeChange)

  // const continueCancelProps = {
  //   prevText: t('jointly_owned_vehicle_info.back'),
  //   prevURL: `/${i18n.language}${t('routes.listed_permits')}`,
  //   nextText: t('jointly_owned_vehicle_info.next'),
  // }

  // useEffect(() => {
  //   try {
  //     if (!nsHealthCard && !driverLicence && !vehiclePermit && !registeredByName) {
  //       history.push(`/${i18n.language}${t('routes.address_type_change')}`)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }, [])

  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get("isSummary") ?? false);
  }, [history]);

  const onNext = () => {
    try {
      if (validateFields()) {

        if (editMasterNumber) {
          dispatch(
            listEditAction('jointlyOwnedVehicleInformation', {
              name, jointMasterNumber
            })
          );
        } else {
          if (findDuplicateMasterNumber(jointMasterNumber, houseHoldMembers, jointVehicles, businessVehicles)) {
            setErrMsg('household_list.found_duplicate')
            return;
          }
          dispatch(listAddAction("jointlyOwnedVehicleInformation", {
            name, jointMasterNumber
          }));
        }
        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          history.push(`/${i18n.language}${t('routes.jointly_owned_summary')}`)
        }

      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      validateName(name)
      validateJointMasterNumber(jointMasterNumber)

      if (name === '') {
        setNameValid(false)
      }
      if (jointMasterNumber === '') {
        setJointMasterNumberValid(false)
      }

      return (
        nameValid === true &&
        jointMasterNumberValid === true &&

        name !== '' &&
        jointMasterNumber !== ''
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ& ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          setNameValid(true)
        } else {
          setNameValid(false)
          setNameError('jointly_owned_vehicle_info.name_error_invalid')
        }
      } else {
        setNameValid(false)
        setNameError('jointly_owned_vehicle_info.name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateJointMasterNumber = (number) => {
    try {
      const regex = RegExp(/^[a-zA-Z\s]{5}[0-9]{9}$/i)
      if (!number) {
        setJointMasterNumberValid(false)
        setJointMasterNumberError('jointly_owned_vehicle_info.joint_master_number_error')
        return;
      }
      if (regex.test(number)) {
        setJointMasterNumberValid(true)
      } else {
        setJointMasterNumberValid(false)
        setJointMasterNumberError('jointly_owned_vehicle_info.joint_master_number_error_invalid')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const onHandleAddPersonalInfo = (e) => {
    e.preventDefault();
    dispatch(changeObjectPropertyAction('addressTypeChange', 'driverLicence', true))
    if (driverLicence) {
      history.push(`/${i18n.language}${t('routes.household_list')}`)
    } else {
      history.push(`/${i18n.language}${t('routes.personal_info')}`)
    }
  }


  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12 col-lg-12">
              <h1>{t('jointly_owned_vehicle_info.title')}</h1>
              <div className={styles['jointly-owned-vehicle-info-container']}>
                <i aria-label={t('shared.warning')} className={"fa fa-exclamation-triangle error-indicator fa-2x has-warning errorAlert " + styles['warning-alert']} aria-hidden="true"></i>
                <p><strong>{t('jointly_owned_vehicle_info.the_address_change')}<br /></strong>
                  {t('jointly_owned_vehicle_info.if_you_need_to_change')}
                  {/* eslint-disable-next-line*/}
                  <a onClick={onHandleAddPersonalInfo} href="#">
                    {' '}
                    {t('jointly_owned_vehicle_info.change_the_address_on')}
                    {'.'}
                  </a>
                </p>
              </div>

            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Name
                validateName={validateName}
                nameError={nameError}
                nameValid={nameValid}
                setIsError={setIsError}
              />
              <JointMasterNumber
                validateJointMasterNumber={validateJointMasterNumber}
                jointMasterNumberError={jointMasterNumberError}
                jointMasterNumberValid={jointMasterNumberValid}
                setIsError={setIsError}
              />
            </div>
          </div>
          <ContinueCancelButtons continueClick={onNext} errorText={errMsg} />
        </article>
      </main>
    </div>
  )
}

export default withTranslation('common')(PersonalInformationView)
